export enum WebSocketSubscription {
  Auction = 'auction',
}
